/* eslint-disable react-refresh/only-export-components */ // Provider file exports hooks and provider in one module for simplicity
import { createContext, ReactNode, useContext, useState } from 'react';

// Minimal context for cross-page coordination only
interface SimpleAudioContextType {
  // Track if we need to refresh history when navigating to it
  shouldRefreshHistory: boolean;
  setShouldRefreshHistory: (value: boolean) => void;

  // Track current session note ID for distinguishing from history
  currentSessionNoteId: string | null;
  setCurrentSessionNoteId: (id: string | null) => void;

  // Reset all state (for logout)
  resetAudioState: () => void;
}

const SimpleAudioContext = createContext<SimpleAudioContextType | null>(null);

export const useSimpleAudio = () => {
  const context = useContext(SimpleAudioContext);
  if (!context) {
    throw new Error('useSimpleAudio must be used within SimpleAudioProvider');
  }
  return context;
};

interface SimpleAudioProviderProps {
  children: ReactNode;
}

export const SimpleAudioProvider = ({ children }: SimpleAudioProviderProps) => {
  const [shouldRefreshHistory, setShouldRefreshHistory] = useState(false);
  const [currentSessionNoteId, setCurrentSessionNoteId] = useState<
    string | null
  >(null);

  const resetAudioState = () => {
    setShouldRefreshHistory(false);
    setCurrentSessionNoteId(null);
  };

  const value = {
    shouldRefreshHistory,
    setShouldRefreshHistory,
    currentSessionNoteId,
    setCurrentSessionNoteId,
    resetAudioState,
  };

  return (
    <SimpleAudioContext.Provider value={value}>
      {children}
    </SimpleAudioContext.Provider>
  );
};
